import { useMutation } from "@tanstack/react-query";
import { type Role } from "@packsize/identity-api-sdk";
import { useIdentityClient } from "@packsize/authentication";

import { queryClient } from "@/lib/query-client";
import { COMPANY_ROLES_QUERY_KEY, ROLES_QUERY_KEY } from "@/hooks/roles/use-roles";

export const useDeleteRole = () => {
	const { client } = useIdentityClient();

	return useMutation({
		mutationFn: async (role: Role) => {
			const result = await client.removeRole(role.id);

			if (!result.success) {
				throw new Error("Failed to delete role");
			}

			return result.data;
		},
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: [ROLES_QUERY_KEY] });
			await queryClient.invalidateQueries({ queryKey: [COMPANY_ROLES_QUERY_KEY] });
		},
	});
};
